
import Vue from "vue";
import {Validatable} from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			isFocused: false,
			selectedItem: 0,
			currentTimeout: null as number | null,
			isOpened: false,
			shownValue: "" as string,
			itemSelected: false
		};
	},
	props: {
		value: String,
		label: [String, Object],
		placeholder: [String, Object],
		open: Boolean,
		items: {
			type: Array as () => any[],
			default() {
				return [];
			}
		},
		up: Boolean,
		fancy: Boolean,
		tabindex: [String, Number],
		inputDelay: {
			type: Number,
			default: 0,
		},
		autoFocusNext: Boolean,
		disabled: Boolean,
		hasError: Boolean,
		emptyOnFocus: Boolean,
		selectOnFocus: Boolean,
		selectOnTab: Boolean,
		icon: String,
		iconLeft: String,
		iconTooltip: [String, Object],
		iconLeftTooltip: [String, Object],
		autoUp: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		stringValue(): string {
			return this.value || "";
		},
		inputElement(): HTMLInputElement {
			return (this.$refs.inputElement as any).$refs.inputElement;
		},
		_iconClickHandler(): Function | undefined {
			return this.$listeners["icon-click"] as Function || undefined;
		},
		_iconLeftClickHandler(): Function | undefined {
			return this.$listeners["icon-left-click"] as Function || undefined;
		}
	},
	watch: {
		items(newValue: any[]) {
			this.selectedItem = 0;
		},
		selectedItem(newValue: number) {
			if (newValue < 0) {
				this.selectedItem = 0;
			}
			if (!this.items) {
				this.selectedItem = -1;
				return;
			}
			if (newValue >= this.items.length) {
				this.selectedItem = this.items.length;
			}

			if (!this.$refs.items) return;
			let selectedItem = (this.$refs.items as Vue[])[this.selectedItem];
			if (selectedItem) {
				(this.$refs.scroller as any).scrollTo(selectedItem.$el);
			}
		},
		isFocused(newVal: boolean) {
			if (newVal) {
				this.$emit("focus");
			} else {
				this.$emit("blur");
			}
		},
		value: {
			immediate: true,
			handler(newValue: string) {
				this.shownValue = newValue;
			}
		}
	},
	methods: {
		focus() {
			this.inputElement.focus();
		},
		blur() {
			this.inputElement.blur();
		},
		onInput(value: string) {
			this.$emit("realtime-value", value);
			if (!this.inputDelay){
				this.$emit("input", value);
			} else {
				if (this.currentTimeout) {
					clearTimeout(this.currentTimeout);
				}
				this.currentTimeout = setTimeout(() => {
					this.$emit("input", value);
				}, this.inputDelay);
			}
		},
		onFocus() {
			if(this.disabled){
				return false;
			}
			this.isOpened = true;
			this.isFocused = true;
			this.itemSelected = false;
			if (this.emptyOnFocus) {
				this.shownValue = "";
			}
			if (this.inputElement.selectionEnd  != null) {
				if (this.inputElement.selectionEnd <= 0 && this.shownValue != "") {
					this.inputElement.select();
				}
			}
		},
		onBlur() {
			this.isOpened = false;
			this.isFocused = false;
			this.$emit("input", this.shownValue);
			if (this.items.length != 0 && !this.itemSelected && this.selectOnTab) {
				this.itemClicked(this.items[this.selectedItem]);
				if (!this.shownValue) {
					this.shownValue = this.value;
				}
			} else if (this.emptyOnFocus) {
				this.shownValue = this.value;
			}
		},
		onKeyDown(event: KeyboardEvent) {
			this.isOpened = true;
			if (event.key == "ArrowDown") {
				this.selectedItem++;
			}
			if (event.key == "ArrowUp") {
				this.selectedItem--;
			}
			this.$emit("keydown", event);
		},
		keyup(event: KeyboardEvent) {
			if (event.key == "Enter") {
				if (this.items.length != 0) {
					if (this.items[this.selectedItem]) {
						this.itemClicked(this.items[this.selectedItem]);
					} else {
						this.$emit("enter");
					}
				}
			}
			this.$emit("keyup", event);
		},
		async itemClicked(event: any) {
			this.$emit("item-click", event);
			this.isOpened = false;
			this.itemSelected = true;
		},
	}
})
;